import _ from 'lodash';
import DataSvc from './data';

export default {
  data() {
    return {
      attachment: null,
      uploading: false,
      fileOptions: [],
      attachmentFields: [
        {
          key: 'remove',
          class: 'remove-file',
          label: '',
        },
        {
          key: 'filename',
        },
        {
          key: 'created',
          label: 'Uploaded On',
        },
      ],
    };
  },
  methods: {
    isFileAttached(attachedFileUUIDs, file) {
      return attachedFileUUIDs.includes(file.uuid);
    },
    toggleAttachment(attachedFileUUIDs, file) {
      if (this.isFileAttached(attachedFileUUIDs, file)) {
        _.pull(attachedFileUUIDs, file.uuid);
      } else {
        attachedFileUUIDs.push(file.uuid);
      }

      this.$forceUpdate();
    },
    uploadFile(attachedFileUUIDs, idKey, idValue) {
      const data = new FormData();

      data.append('file', this.attachment);
      data.append(idKey, idValue);
      this.uploading = true;

      return DataSvc.uploadFile(data)
        .then((file) => {
          // add file to list of selectable file options
          this.fileOptions.push(file);

          // auto-select uploaded file
          attachedFileUUIDs.push(file.uuid);

          // clear file upload input
          this.attachment = null;
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    downloadRegistrationFiles(registrationID) {
      const data = {
        registration_id: registrationID,
      };

      this.submitting = true;

      return DataSvc.downloadFileArchive(data)
        .then(({ url }) => {
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', 'archive.zip');
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
